import { createFileRoute } from '@tanstack/react-router'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { ReportComponent } from './-components/report/report'
import { prefetchReport } from '@/hooks/use-report'

export const Route = createFileRoute('/_app/teams/$teamId/report')({
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) => {
    prefetchReport(context.queryClient, deps, params)
  },
  component: RouteComponent,
  pendingComponent: NestedReportPending,
})

function RouteComponent() {
  return <ReportComponent />
}
